import React from 'react';
import { inject, observer } from "mobx-react";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// Translations
import _useTranslate from '../hooks/_useTranslate';

const RestaurantClosed = ({feathersStore})=> {

  let footer = _useTranslate(feathersStore.language, "footer"); 
  
  const close = () => {
    feathersStore.setShowRestaurantMessage(false)
  }

  return (
    <div className="restaurant-closed-body-container">
      <div className="restaurant-closed-header">
        <div className="restaurant-closed-content">
          <ErrorOutlineOutlinedIcon />
          <div className="restaurant-closed-text">
            {feathersStore.settings?.closedShopText ? 
              feathersStore._translateClosedShopText()
            : footer.restaurantClosed}
          </div>
          {/* Optional: Show opening hours if available */}
          {feathersStore.settings?.openingHours && (
            <div className="restaurant-hours">
              <AccessTimeIcon />
              <span>{feathersStore.settings.openingHours}</span>
            </div>
          )}
        </div>
        <div className="cancel-restaurant-message-icon" onClick={close}>
          <CancelOutlinedIcon/>
        </div>     
      </div>
    </div>
  );
  
}

export default inject('feathersStore')(observer(RestaurantClosed));